import { createAction, props } from '@ngrx/store';

export const changeVisibilityOfBackendError = createAction(
  '[BackendError] Update visibility of BackendErrorPopup',
  props<{
    showBackendErrorPopup: boolean;
  }>(),
);

export const setVisibilityOfCustomerChat = createAction(
  '[Chat] Set visibility of Genesys chat',
  props<{
    showCustomerChat: boolean;
  }>(),
);

export const setMaintenanceModeEnabled = createAction(
  '[App] Set visibility of maintenance mode screen',
  props<{
    showMaintenanceModeScreen: boolean;
  }>(),
);

export const setYouthHealthPackagesEnabled = createAction(
  '[Offer] Set visibility of youth health packages screen',
  props<{
    showYouthHealthPackages: boolean;
  }>(),
);

export const setVisibilityOfAdvancedMedicSearch = createAction(
  '[Chat] Set visibility of advanced medic search',
  props<{
    showAdvancedMedicSearch: boolean;
  }>(),
);

export const setJevUnapprovedPremiumHintEnabled = createAction(
  '[Offer] Set visibility of the hint about premiums not yet approved by FINMA',
  props<{
    showJevUnapprovedPremiumHint: boolean;
  }>(),
);
